import { Card } from "../Card";
import { useState } from "react";
import { Button } from "@staccx/bento";
import DocumentDialog from "./DocumentDialog";
import { CloseDocumentButton } from "../../../../theme/Theme.Button";
import BudgetPreview from "./BudgetPreview";
import styled from "styled-components";
import { displayBudgetText } from "../displayBudgetText";

const BudgetCheckboxListItem = ({ flow, selectedValues, handleChange }) => {
	const [showDialog, setShowDialog] = useState(false);

	const budgetData = flow.data.budgetData;

	return (
		<>
			<Card
				key={flow.flowId}
				icon={
					<Checkbox
						type="checkbox"
						checked={selectedValues.includes(flow.flowId)}
						onChange={() => handleChange(flow.flowId)}
					/>
				}
				title={displayBudgetText({
					...budgetData,
					signingType: flow?.data?.signingType,
				})}
				action={
					<Button variant={"goto"} onClick={() => setShowDialog(true)}>
						Forhåndsvis
					</Button>
				}
			></Card>

			<DocumentDialog
				open={showDialog}
				onOpenChange={setShowDialog}
				width="fit-content"
			>
				<CloseDocumentButton onClick={() => setShowDialog(false)} />
				<BudgetPreview
					flowId={flow.flowId}
					attachmentKey={budgetData.document.attachmentId}
					mimeType={budgetData.document.mimetype}
					budget={budgetData}
				/>
			</DocumentDialog>
		</>
	);
};

const Checkbox = styled.input`
  margin-right: 5px;
  width: 20px;
  height: 20px;
  padding: 15px;
  box-sizing: border-box;
`;

export default BudgetCheckboxListItem;
